'use client';
// src/components/action-area/constants.ts
var ACTION_AREA_NAME = "ActionArea";
var ACTION_AREA_BUTTON_NAME = "ActionAreaButton";

export { ACTION_AREA_BUTTON_NAME, ACTION_AREA_NAME };
